// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"app-pages-settings--heading","profileSettings":"app-pages-settings--profileSettings"};